import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'residentCompanies-wrap-container';

export default function residentCompanies() {
  const widgetName = 'residentCompanies';
  const widgetOpts = residentCompaniesOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createresidentCompanies(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createresidentCompanies(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      validateUrl(URL, $cardItem);
      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}
